import LocationService from './service';

const service = new LocationService();

export default service;
